import { createContext } from 'react';

export interface PreparedPaymentCustomer {
  leadId: string;
  formId: string;
  name: string;
  email: string;
  phone: string;
}

export interface CompletedPaymentDetails {
  fieldName: string;
  leadId: string;
  paymentId: string;
  provider?: string;
}

export type PaymentFieldStatus = 'idle' | 'processing' | 'done' | 'error';

export interface PaymentFieldStatusState {
  status: PaymentFieldStatus;
  errorMessage: string;
}

export const PaymentSubmissionContext = createContext<
  {
    preparePayment: () => Promise<PreparedPaymentCustomer>;
    completePayment: (
      fieldName: string,
      payment: CompletedPaymentDetails,
    ) => Promise<void>;
    getPaymentStatus: (
      fieldName: string,
    ) => PaymentFieldStatusState | undefined;
    setPaymentStatus: (
      fieldName: string,
      state: PaymentFieldStatusState,
    ) => void;
    advanceAfterPayment: () => void;
  } | null
>(null);
